import { OAuth2 } from '@backstage/core-app-api';
import {
  BackstageIdentityApi,
  configApiRef,
  createApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
} from '@backstage/core-plugin-api';
import { createApp } from '@backstage/frontend-defaults';
import {
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { ThinkSignInPage } from './modules/auth/ThinkSignInPage';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { themeModule } from './modules/theme';

const fusionAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>({
  id: 'auth.fusionauth',
});

const fusionAuthApi = ApiBlueprint.make({
  name: 'fusionauth',
  params: defineParams =>
    defineParams({
      api: fusionAuthApiRef,
      deps: {
        configApi: configApiRef,
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
      },
      factory: ({ configApi, discoveryApi, oauthRequestApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          environment: configApi.getOptionalString('auth.environment'),
          provider: {
            // This must match the standard OIDC provider ID in the backend.
            id: 'oidc',
            title: 'THiNK',
            icon: () => null,
          },
          defaultScopes: ['openid', 'profile', 'email'],
        }),
    }),
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <ThinkSignInPage
          {...props}
          provider={{
            id: 'fusionauth-auth-provider',
            title: 'THiNK Engineering',
            message: 'Sign in with THiNK',
            apiRef: fusionAuthApiRef,
          }}
        />
      ),
  },
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    homeModule,
    themeModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [fusionAuthApi, signInPage],
    }),
  ],
});
